module.exports = __webpack_public_path__ + "static/media/resume-preview.6146a2ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/resume-preview.png
// module id = 160
// module chunks = 0